import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { isAllowedToMakeCCPayment } from "js/utilities";
import { isPolicyInactiveByPolicyStatus } from "js/utilities";

import ServicesAndClaimsCard from "components/ServicesAndClaims/ServicesAndClaimsCard";

export default function ServicesLifeInsurance() {
  const { policies } = useSelector((state) => state.data);
  const { t } = useTranslation();

  const anyPolicyCanMakeCCPayment = () => {
    return policies.find((p) => isAllowedToMakeCCPayment(p, "onetimepayment"));
  };

  useBreadcrumb([
    { name: "Home", url: "/policies" },
    { name: "Services and Claims", url: "/services-claims" },
    { name: "Life Insurance", url: "#" },
  ]);

  // hiding payment services when all policies are in terminated status
  const [showPaymentServices, setShowPaymentServices] = useState(false);
  useEffect(() => {
    policies.forEach((policy) => {
      if (!isPolicyInactiveByPolicyStatus(policy?.status))
        setShowPaymentServices(true);
    });
  }, [policies]);

  return (
    <>
      <div className="container mb-8">
        <h1>{t("CustomerLifeInsuranceServices-title")}</h1>
        <p>{t("CustomerLifeInsuranceServices-subtitle")}</p>
        <hr />
      </div>

      <div className="container ui-component-spacing">
        <div className="grid grid-cols-1 auto-rows-fr gap-4 mt-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6 md:mt-6">
          {showPaymentServices && (
            <ServicesAndClaimsCard
              data={{
                title: t("CustomerLifeInsuranceServices-card-1-title"),
                desc: t("CustomerLifeInsuranceServices-card-1-desc"),
                subTitle: t("CustomerLifeInsuranceServices-card-1-subTitle"),
                links: [
                  ...(anyPolicyCanMakeCCPayment()
                    ? [
                        {
                          title: t(
                            "CustomerLifeInsuranceServices-card-1-link-1-title"
                          ),
                          icon: t(
                            "CustomerLifeInsuranceServices-card-1-link-1-icon"
                          ),
                          url: t(
                            "CustomerLifeInsuranceServices-card-1-link-1-url"
                          ),
                        },
                      ]
                    : []),
                  {
                    title: t(
                      "CustomerLifeInsuranceServices-card-1-link-2-title"
                    ),
                    icon: t("CustomerLifeInsuranceServices-card-1-link-2-icon"),
                    url: t("CustomerLifeInsuranceServices-card-1-link-2-url"),
                  },
                ],
              }}
            />
          )}

          <ServicesAndClaimsCard
            data={{
              title: t("CustomerLifeInsuranceServices-card-2-title"),
              desc: t("CustomerLifeInsuranceServices-card-2-desc"),
              subTitle: t("CustomerLifeInsuranceServices-card-2-subTitle"),
              links: [
                {
                  title: t("CustomerLifeInsuranceServices-card-2-link-1-title"),
                  icon: t("CustomerLifeInsuranceServices-card-2-link-1-icon"),
                  url: t("CustomerLifeInsuranceServices-card-2-link-1-url"),
                },
                {
                  title: t("CustomerLifeInsuranceServices-card-2-link-2-title"),
                  icon: t("CustomerLifeInsuranceServices-card-2-link-2-icon"),
                  url: t("CustomerLifeInsuranceServices-card-2-link-2-url"),
                },
              ],
            }}
          />
        </div>
      </div>
    </>
  );
}
